import { ShipmentListFiltersETASources } from '../../models/shipment-common-models/shipment-eta-sources-filter.model';

export enum Origin {
  TMS = 'TMS',
  TMSEurolog = 'TMS_EUROLOG',
  Waybill = 'WAYBILL',
  Gate = 'GATE',
  Web = 'WEB',
  ERP = 'ERP',
}

export enum ShipmentOrigin {
  TMS = 'TMS',
  TMSEurolog = 'TMS_EUROLOG',
  TMSLisa = 'TMS_LISA',
  Waybill = 'WAYBILL',
  EdiManager = 'EDI_MANAGER',
  CPTOutbound = 'CPT_OUTBOUND',
  Web = 'WEB',
}

export enum AutomotiveAftermarketOrigin {
  TMS = 'TMS',
  TMSEurolog = 'TMS_EUROLOG',
  Gate = 'GATE',
  Web = 'WEB',
}

export const customFilterTitles = {
  [Origin.TMS]: 'TMS - INET',
  [Origin.TMSEurolog]: 'TMS - EUROLOG',
  [Origin.Waybill]: 'Intercontinental - Waybill',
  [Origin.Gate]: 'Dock & Yard - Gate',
  [Origin.Web]: 'Dock & Yard - Web',
  [Origin.ERP]: 'Dock & Yard - ERP',
  [ShipmentOrigin.CPTOutbound]: 'FD - Outbound',
  [ShipmentOrigin.TMSLisa]: 'TMS - LISA (SOFA)',
  [ShipmentListFiltersETASources.BestFit]: 'BestFit',
};

export enum DeliveryService {
  FFF = 'FFF',
  FLL = 'FLL',
  STD = 'STD',
  EMT = 'EMT',
  CAS = 'CAS',
  Unknown = 'UNKNOWN',
}

export enum ServiceLevel {
  STD = 'STD',
  SPC = 'SPC',
  EMG = 'EMG',
  Unknown = 'UNKNOWN',
}

export enum Region {
  Europe = 'EUROPE',
  China = 'CHINA',
  NorthAmerica = 'NORTH_AMERICA',
  India = 'INDIA',
  Unknown = 'UNKNOWN',
}
